import React, { useState } from 'react';

import { Captcha } from 'primereact/captcha';
import { useNavigate, useLocation } from 'react-router-dom';

import 'react-toastify/dist/ReactToastify.css';

import { isEmail } from 'validator';
import { toast } from 'react-toastify';
import { get } from 'lodash';
import { InputText } from 'primereact/inputtext';
import IconButton from '../components/IconButton';

import Card from '../components/card';

import { Input155px } from '../styles/inputGroup';
import Loading from './loading';
import axiosCoto from '../services/axiosCoto';
import { SITEKEY } from '../config/constantes';

export default function ConfirmacaoAlteracaoSenha() {
  const navigate = useNavigate();

  const { search } = useLocation();

  const [email, setEmail] = useState(new URLSearchParams(search).get('email'));
  const token = useState(new URLSearchParams(search).get('k'));

  const [isLoading, setIsLoading] = useState(false);
  const [captchaResponse, setCaptchaResponse] = useState();

  async function salvarRegistro() {
    try {
      setIsLoading(true);

      const captcha = captchaResponse.response;

      const shippingData = {
        email,
        token: token[0],
        captcha,
      };

      await axiosCoto.put('/usuario/confirmaralteracaosenhaporemail', shippingData);

      toast.success('Nova senha alterada com sucesso.');

      navigate('/login');
    } catch (err) {
      const errors = get(err.response.data, 'errors', []);

      if (errors.length > 0) {
        errors.map(error => toast.error(error));
      } else {
        toast.error('Não foi possível alterar a senha.');
      }
    } finally {
      setIsLoading(false);
    }
  }

  const handleCancel = () => {
    navigate('/login');
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let formErros = false;

    if (!captchaResponse) {
      formErros = true;
      toast.error('Mostre que você não é um robô.');
    }

    if (!isEmail(email)) {
      formErros = true;
      toast.error('Email inválido.');
    }

    if (!token) {
      formErros = true;
      toast.error('Token deve ser informado.');
    }
    if (formErros) return;

    salvarRegistro();
  };

  const isReady = () => typeof window !== 'undefined' && typeof window.grecaptcha !== 'undefined' && typeof window.grecaptcha.render === 'function';

  return (
    <div>
      <Loading isLoading={isLoading} />
      <Card>
        <div className="row form-elo">
          <div className="col-12">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                E-mail
              </Input155px>
              <InputText
                id="inputEmail"
                maxLength={254}
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </div>
          </div>
          <br />
          <div className="col-12">
            <br />
            <Captcha
              siteKey={SITEKEY}
              onResponse={setCaptchaResponse}
              language="pt-br"
              isReady={isReady}
            />
          </div>
        </div>
        <div className="col-12" style={{ textAlign: 'right' }}>
          <IconButton titulo="Enviar" mensagem="Enviar" btnStyle="success" onClick={handleSubmit} icon="check" />
          <IconButton titulo="Cancelar" mensagem="Cancelar" btnStyle="danger" onClick={handleCancel} icon="times" />
        </div>
      </Card>
    </div>
  );
}
